module.exports = __webpack_public_path__ + "static/media/ic_cotizacion_tarjeta.c12390e3.svg";